<template>
    <b-container class="p-0 welcome-div" fluid>
        <div class="mb-1 mt-1 xs-hidden sm-hidden">
            <agile :autoplay="true" :autoplaySpeed="6000" @after-change="e => currentSlide = e.currentSlide">
                <div class="slide-agile-img hoverDrag h-100">

                    <b-img @click="routerSeason('verano', 2026)"
                        src="https://ctworker.com/images/index_images/tony_slider_verano.jpg" fluid
                        alt="Responsive image" class="hoverDrag"></b-img>
                </div>
                <div class="slide-agile-img hoverDrag h-100">

                    <b-img @click="routerSeason('verano', 2026)"
                        src="https://ctworker.com/images/index_images/tony_slider_verano_2.jpg" fluid
                        alt="Responsive image" class="hoverDrag"></b-img>
                </div>
                <template slot="prevButton"><i class="fas fa-chevron-left"></i></template>
                <template slot="nextButton"><i class="fas fa-chevron-right"></i></template>
            </agile>
        </div>
        <b-row class="w-100 mx-0">
            <b-col cols="12" sm="4" class="p-0 prod">
                <h6 class="w-text font-abril-fatface f-white font-cincel">Verano 2026</h6>
                <router-link :to="{ name: 'Season', params: { season: 'verano', year: '2026' } }">
                    <b-img center class="hoverHand" fluid
                        src="https://ctworker.com/images/index_images/1_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod-background b-yellow">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Vestidos y Jesusines</h6>
                <router-link
                    :to="{ name: 'Family', params: { season: 'verano', year: 2026, family: 'Vestidos y Jesusines'}}">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/2_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Conjuntos</h6>
                <router-link :to="{ name: 'Family', params: { season: 'verano', year: 2026, family: 'Conjuntos'}}">
                    <b-img center class="hoverHand" fluid
                        src="https://ctworker.com/images/index_images/3_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod-background b-green">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Punto</h6>
                <router-link :to="{ name: 'Family', params: { season: 'verano', year: 2026, family: 'Punto' } }">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/4_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Accesorios</h6>
                <router-link :to="{ name: 'Family', params: { season: 'verano', year: 2026, family: 'Accesorios' } }">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/5_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod-background b-pink">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Muditas y Pijamas</h6>
                <router-link :to="{ name: 'Family', params: { season: 'verano', year: 2026, family: 'Muditas y Pijamas' } }">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/6_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod xs-hidden sm-hidden">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Petos, Pichis y Ranitas</h6>
                <router-link :to="{ name: 'Family', params: { season: 'verano', year: 2026, family: 'Petos, Pichis y Ranitas' } }">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/7_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod-background b-yellow">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Outlet Verano</h6>
                <router-link
                    :to="{ name: 'Season', params: { season: 'verano', year: 2025 } }">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/8_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
            <b-col cols="12" sm="4" class="p-0 prod">
                <h6 class="w-text font-abril-fatface font-black font-cincel">Outlet Invierno</h6>
                <router-link :to="{ name: 'Season', params: { season: 'invierno', year: 2025} }">
                    <b-img center class="hoverHand" fluid src="https://ctworker.com/images/index_images/9_tony_portada.jpg" alt="Image 2"></b-img>
                </router-link>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    name: 'Welcome',
    data() {
        return {
            currentSlide: 0,
            captions: [
                '',
                '',
            ]
        }
    },
    created() {
        document.title = 'Tony Bambino'
    },
    methods: {
        routerSeason(season, year) {
            const info = {
                season: season.charAt(0).toUpperCase() + season.slice(1),
                year: year
            }
            if (this.user !== null) {
                this.$root.$emit('season', info)
                this.$root.$emit('loader', true)
                this.$store.dispatch('getSeasonProducts', info)
            }

            if (season !== this.$route.name && year !== this.$route.params) {
                this.$router.push({ name: 'Season', params: { season: season, year: year } }).catch(() => { })
            }
        },
    },
}
</script>
